import { render } from "./SendWhatsAppButton.vue?vue&type=template&id=66d181c8&scoped=true"
import script from "./SendWhatsAppButton.vue?vue&type=script&lang=js"
export * from "./SendWhatsAppButton.vue?vue&type=script&lang=js"

import "./SendWhatsAppButton.vue?vue&type=style&index=0&id=66d181c8&scoped=true&lang=css"

import exportComponent from "D:\\Proyectos\\ERP ELECTRONICO\\ERP-FRONT\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66d181c8"]])

export default __exports__